export default class Service {
    constructor(element) {
        if (element) { // use this element in all other Service objects
            Service.element = element;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    get tagName() {
        var _a, _b;
        return (_b = (_a = Service.element) === null || _a === void 0 ? void 0 : _a.tagName.toLowerCase()) !== null && _b !== void 0 ? _b : 'unknown';
    }
    log(message, ...args) {
        console.log(`${this.tagName}:`, message, ...args); // eslint-disable-line no-console
    }
    logInfo(message, ...args) {
        console.info(`${this.tagName}:`, message, ...args); // eslint-disable-line no-console
    }
    logError(message, ...args) {
        console.error(`${this.tagName}:`, message, ...args); // eslint-disable-line no-console
    }
    fireEvent(details) {
        var _a;
        const event = new CustomEvent(this.tagName, {
            bubbles: true,
            composed: true,
            detail: details,
        });
        (_a = Service.element) === null || _a === void 0 ? void 0 : _a.dispatchEvent(event);
    }
}
//# sourceMappingURL=Service.js.map